import React, { useState } from "react";
import { useEffect } from "react";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import {
  getCounts,
  adultInc,
  adultDec,
  childInc,
  childDec,
  infantInc,
  infantDec,
  fetchAirportsAsync,
  getAirportsList,
  flightSearchAsync,
  getLoading,
  setFlightCounts,
  ResetLoader,
  ResetFlightSearch,
} from "../../features/bookings/flightSlice";
import { useForm } from "../../hooks/useForm";
import SearchButton from "../UI/SearchButton";
import moment from "moment";
import Loader from "../../helpers/Loader";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
} from "react-router-dom";
import SingleCounter from "../UI/SingleCounter";
import { slashFormatter } from "../../helpers/helper";

const FlightForm = () => {
  const [pickUp, setPickUp] = useState("");
  const [pickUpCity, setPickUpCity] = useState(null);
  const [hoverPickup, setHoverPickup] = useState(false);
  const [dropOff, setDropoff] = useState("");
  const [dropOffCity, setDropOffCity] = useState(null);
  const [directFlight, setDirectFlight] = useState(false);
  const [hoverDropoff, setHoverDropoff] = useState(false);

  const [tripType, setTripType] = useState("1");

  const customValidate = (errors) => {
    if (pickUp.trim() !== "" && state["pickUp"] === "") {
      errors.pickUp = "Select a valid airport!";
    }
    if (dropOff.trim() !== "" && state["dropOff"] === "") {
      errors.dropOff = "Select a valid airport!";
    }

    if (state["DepartureDate"].trim() === "") {
      errors.DepartureDate = "Select departure date!";
    }

    if (tripType === "2") {
      if (state["ReturnDate"]?.trim() === "") {
        errors.ReturnDate = "Select return date!";
      }
    } else {
      delete errors["ReturnDate"];
    }

    return errors;
  };

  const handleApplyBtn = () => {
    setDropdown("");
    setPlaceHolder(
      `${adultsCount} Adult - ${childsCount} Child, ${infantsCount} Infants`,
    );
  };

  const {
    state,
    setState,
    handleFormSubmit,
    formErrors,
    checkErrors,
    isSubmit,
  } = useForm({
    val: { pickUp: "", dropOff: "", DepartureDate: "" },
    inValidate: customValidate,
    withSubmit: handleApplyBtn,
  });

  const [locationType, setLocationType] = useState(0);

  const [fareType, setFareType] = useState("regular");
  const [travelClass, setTravelClass] = useState("1");
  const [focused, setFocused] = useState("");

  const [dropdown, setDropdown] = useState("");
  const [placeHolder, setPlaceHolder] = useState(
    "1 Adult - 0 Child - 0 Infant",
  );
  const [departure, setDeparture] = useState(
    new Date().setFullYear(new Date().getFullYear()),
  );
  const [returnDate, setReturnDate] = useState("");
  const todayMinDate = new Date().setFullYear(new Date().getFullYear());
  const endDateAll = new Date().setFullYear(new Date().getFullYear() + 1);
  const [minReturn, setMinReturn] = useState(todayMinDate);

  const [pickUpList, setPickupList] = useState([]);
  const [dropOffList, setDropoffList] = useState([]);
  const [searchParams] = useSearchParams();
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams]),
  );

  const { adultsCount, childsCount, infantsCount } = useSelector(getCounts);
  const airList = useSelector(getAirportsList);
  const loading = useSelector(getLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setPickupList([]);
    setDropoffList([]);
  }, [window.location.pathname]);

  useEffect(() => {
    dispatch(ResetLoader());
    dispatch(ResetFlightSearch());
  }, []);

  useEffect(() => {
    if (airList.length > 0) {
      if (focused === "pickUp") {
        setPickupList(airList);
      } else if (focused === "dropOff") {
        setDropoffList(airList);
      }
    }
  }, [airList, focused]);

  const setForm = (vals) => {
    const { pickUp, dropOff, DepartureDate } = JSON.parse(vals?.state) || {};

    setPickUp(pickUp.name);
    setDropoff(dropOff.name);

    const { adultsCount, childsCount, infantsCount } = vals;
    setPlaceHolder(
      `${adultsCount} Adult - ${childsCount} Child, ${infantsCount} Infants`,
    );
    dispatch(setFlightCounts({ adultsCount, childsCount, infantsCount }));
    setDeparture(
      new Date(DepartureDate).getTime() -
        new Date(DepartureDate).getTimezoneOffset() * 60000,
    );
    setMinReturn(
      new Date(DepartureDate).getTime() -
        new Date(DepartureDate).getTimezoneOffset() * 60000,
    );

    const state = JSON.parse(vals?.state) || {};

    if (state?.ReturnDate !== null && state?.ReturnDate !== undefined) {
      setTripType("2");
      let myDate = new Date(state?.ReturnDate).toISOString().split("T")[0];
      setReturnDate(
        new Date(myDate).getTime() -
          new Date(myDate).getTimezoneOffset() * 60000,
      );
      setState({
        ...state,
        ReturnDate: myDate,
        pickUp,
        dropOff,
        DepartureDate,
      });
    } else {
      setState({
        ...state,
        pickUp,
        dropOff,
        DepartureDate,
      });
    }
  };

  useEffect(() => {
    if (Object.keys(queryData).length > 0) {
      setForm(queryData);
      if (sessionStorage.getItem("flightForm") === null) {
        sessionStorage.setItem(
          "flightForm",
          JSON.stringify({
            state: JSON.parse(queryData.state),
            adultsCount,
            childsCount,
            infantsCount,
            travelClass,
            tripType,
          }),
        );
      }
    } else {
      const val = JSON.parse(sessionStorage.getItem("flightForm"));
      if (val !== null) {
        setForm({ ...val, state: JSON.stringify(val?.state) });
        setPickUpCity(val?.state?.pickUp?.cityname);
        setDropOffCity(val?.state?.dropOff?.cityname);
      }
    }
  }, [queryData]);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      sessionStorage.setItem(
        "flightForm",
        JSON.stringify({
          state,
          adultsCount,
          childsCount,
          infantsCount,
          travelClass,
          tripType,
          directFlight,
        }),
      );
      let obj = {
        state: JSON.stringify(state),
        adultsCount,
        childsCount,
        infantsCount,
        travelClass,
        tripType,
        directFlight,
      };

      {
        obj !== undefined &&
          navigate({
            pathname: "/flight-listing",
            search: `${createSearchParams(obj)}`,
          });
      }
    }
  }, [formErrors, isSubmit]);

  const handleDepartureDate = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    setDeparture(e.getTime() - e.getTimezoneOffset() * 60000);
    setState({
      ...state,
      DepartureDate: new Date(myDate).toISOString().split("T")[0],
    });
    delete formErrors["DepartureDate"];

    setMinReturn(e.getTime() - e.getTimezoneOffset() * 60000);

    if (new Date(myDate) >= new Date(returnDate)) {
      setReturnDate(e.getTime() - e.getTimezoneOffset() * 60000);
      setState({
        ...state,
        ReturnDate: new Date(myDate).toISOString().split("T")[0],
        DepartureDate: new Date(myDate).toISOString().split("T")[0],
      });
      delete formErrors["ReturnDate"];
      delete formErrors["DepartureDate"];
    }
  };

  const handleReturnDate = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    setReturnDate(e.getTime() - e.getTimezoneOffset() * 60000);
    setState({ ...state, ReturnDate: myDate });
    delete formErrors["ReturnDate"];
  };

  const handleRadioButtonChange = (e) => {
    if (e.target.value === "2") {
      setState({ ...state, ReturnDate: "" });
    } else {
      delete state["ReturnDate"];
    }
    setTripType(e.target.value);
  };

  const handleFareChange = (e) => {
    setFareType(e.target.value);
  };

  const handleClassChange = (e) => {
    setTravelClass(e.target.value);
  };

  const handleSwipeLocation = () => {
    let tmp = pickUp;
    setPickUp(dropOff);
    setDropoff(tmp);

    tmp = state.pickUp;
    setState({ ...state, pickUp: state.dropOff, dropOff: tmp });
  };

  const handleInputChange = (e) => {
    if (e.target.value.length < 2) {
      setPickupList([]);
      setDropoffList([]);
    }
    if (e.target.name === "pickUp") {
      setPickUp(e.target.value);
      setState({ ...state, pickUp: "" });
    } else {
      setDropoff(e.target.value);

      setState({ ...state, dropOff: "" });
    }
    setFocused(e.target.name);
    dispatch(fetchAirportsAsync(e.target.value));
  };

  const handleListInput = (value, type) => {
    if (type === "pickUp") {
      setPickupList([]);
      setPickUp(value.name + " " + value.airportcode);
      setPickUpCity(value.cityname);
      setState({ ...state, pickUp: value });
    } else {
      setDropoff(value.name + " " + value.airportcode);
      setDropOffCity(value.cityname);
      setDropoffList([]);
      setState({ ...state, dropOff: value });
    }
  };

  const hoverEnterHandler = (type) => {
    if (type === "pickup" && pickUp !== "") {
      setHoverPickup(true);
    }

    if (type === "dropOff" && dropOff !== "") {
      setHoverDropoff(true);
    }
  };

  const hoverLeaveHandler = (type) => {
    if (type === "pickup") {
      setHoverPickup(false);
    } else {
      setHoverDropoff(false);
    }
  };

  return (
    <>
      <div className="bf-wrap">
        <div className="bf-toolbar">
          <div className="bf-radio-group">
            <label>
              <input
                type="radio"
                name="radio"
                checked={tripType === "1"}
                value="1"
                onChange={handleRadioButtonChange}
              />
              <span>Oneway</span>
            </label>
            <label>
              <input
                type="radio"
                name="radio"
                value="2"
                checked={tripType === "2"}
                onChange={handleRadioButtonChange}
              />
              <span>Round Trip</span>
            </label>
          </div>
          <div className="bf-checkbox-group">
            <label>
              <input
                type="checkbox"
                name="checkbox"
                checked={directFlight}
                value="1"
                onChange={() => setDirectFlight(!directFlight)}
              />
              <span>Direct Flight</span>
            </label>
          </div>
        </div>

        <form action="" className="bf-form">
          <div className="bf-field">
            <button
              type="button"
              className="bf-swap-btn"
              onClick={handleSwipeLocation}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
              >
                <g clipPath="url(#clip0_137_513)">
                  <path
                    d="M0.355323 4.43457C0.533418 4.57705 0.747131 4.59486 0.978654 4.59486C6.26806 4.59486 11.5397 4.59486 16.8291 4.59486C16.9181 4.59486 17.0071 4.59486 17.1674 4.59486C16.651 5.11133 16.1879 5.55657 15.7427 6.01961C15.3509 6.41142 15.3331 6.91009 15.6714 7.26627C16.0276 7.62246 16.5263 7.58684 16.9181 7.19504C17.8442 6.26895 18.7703 5.34286 19.6964 4.41676C20.1238 3.98934 20.1238 3.52629 19.6964 3.09887C18.8949 2.27963 18.0757 1.47821 17.2743 0.676782C17.1496 0.552116 17.025 0.409641 16.8825 0.284975C16.5085 -0.0712142 16.0098 -0.0712142 15.6714 0.267165C15.3331 0.605544 15.3509 1.10421 15.7071 1.47821C16.1167 1.90563 16.5441 2.31525 16.9537 2.72487C17.0071 2.7783 17.0784 2.83172 17.1496 2.88515C17.1318 2.90296 17.1318 2.92077 17.114 2.93858C17.025 2.93858 16.9359 2.93858 16.8291 2.93858C11.5753 2.93858 6.32149 2.93858 1.0677 2.93858C0.978654 2.93858 0.889607 2.93858 0.800559 2.93858C0.444371 2.95639 0.14161 3.20572 0.052563 3.56191C-0.0542937 3.86467 0.0703724 4.22086 0.355323 4.43457Z"
                    fill="currentColor"
                  />
                  <path
                    d="M19.4119 9.6171C19.2694 9.56367 19.1447 9.58148 19.0022 9.58148C13.7306 9.58148 8.45905 9.58148 3.18746 9.58148C3.09841 9.58148 3.00936 9.58148 2.84908 9.58148C3.36555 9.065 3.8286 8.60196 4.29164 8.13891C4.66564 7.76491 4.70126 7.26625 4.36288 6.91006C4.0245 6.55387 3.50803 6.57168 3.11622 6.96349C2.17232 7.90739 1.24623 8.83348 0.30233 9.75957C-0.107287 10.1692 -0.107287 10.6322 0.30233 11.0597C1.24623 11.9858 2.17232 12.9118 3.09841 13.8379C3.49022 14.2297 3.98888 14.2654 4.34507 13.9092C4.70126 13.553 4.66564 13.0543 4.27383 12.6625C3.81079 12.1995 3.34774 11.7364 2.83127 11.2378C2.99156 11.2378 3.0806 11.2378 3.16965 11.2378C8.42343 11.2378 13.6772 11.2378 18.9488 11.2378C19.0379 11.2378 19.1269 11.2378 19.216 11.2378C19.6256 11.2021 19.9461 10.8816 19.9996 10.4898C20.0352 10.098 19.7859 9.74176 19.4119 9.6171Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_137_513">
                    <rect width="20" height="14.1585" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="32"
                viewBox="0 0 26 32"
                fill="none"
              >
                <path
                  d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">From</label>

              {pickUp !== "" && pickUpCity !== null && (
                <h5 className="bf-subvalue">{pickUpCity}</h5>
              )}
              <input
                onMouseEnter={() => hoverEnterHandler("pickup")}
                onMouseLeave={() => hoverLeaveHandler("pickup")}
                type="text"
                className="bf-input"
                placeholder="Enter Airport"
                onChange={handleInputChange}
                onBlur={(e) => {
                  setPickupList([]);
                  checkErrors(e);
                }}
                name="pickUp"
                value={pickUp}
                autoComplete="off"
              />
              {hoverPickup && <p className="bf-hover-tag">{pickUp}</p>}
              <span className="bf-error">{formErrors?.pickUp}</span>

              <ul
                className={`bf-suggestions ${
                  pickUpList.length > 0 ? "is-open" : ""
                }`}
              >
                {pickUpList.length > 0 &&
                  pickUpList.map((val, i) => (
                    <li
                      onMouseDown={() => handleListInput(val, "pickUp")}
                      key={i}
                    >
                      <span className="bf-suggest-main">{val.name}</span>
                      <span className="bf-suggest-sub">
                        {val.airportcode}, {val.cityname}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="32"
                viewBox="0 0 26 32"
                fill="none"
              >
                <path
                  d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">To</label>
              {dropOff !== "" && dropOffCity !== null && (
                <h5 className="bf-subvalue">{dropOffCity}</h5>
              )}
              <input
                type="text"
                className="bf-input"
                placeholder="Enter Airport"
                onChange={handleInputChange}
                name="dropOff"
                onMouseEnter={() => hoverEnterHandler("dropOff")}
                onMouseLeave={() => hoverLeaveHandler("dropOff")}
                onBlur={(e) => {
                  setDropoffList([]);
                  checkErrors(e);
                }}
                value={dropOff}
                autoComplete="off"
              />
              {hoverDropoff && <p className="bf-hover-tag">{dropOff}</p>}
              <span className="bf-error">{formErrors?.dropOff}</span>

              <ul
                className={`bf-suggestions ${
                  dropOffList.length > 0 ? "is-open" : ""
                }`}
              >
                {dropOffList.length > 0 &&
                  dropOffList.map((val, i) => (
                    <li
                      onMouseDown={() => handleListInput(val, "dropOff")}
                      key={i}
                    >
                      <span className="bf-suggest-main">{val.name}</span>
                      <span className="bf-suggest-sub">
                        {val.airportcode}, {val.cityname}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="24"
                viewBox="0 0 32 24"
                fill="none"
              >
                <path
                  d="M31.9917 3.62245C31.6948 4.66189 30.8616 5.18986 29.9789 5.61884C27.7102 6.70778 25.4251 7.76372 23.1482 8.82791C19.3452 10.6016 15.5339 12.3752 11.7309 14.1571C10.3202 14.8171 8.83527 15.1966 7.2926 15.3533C6.35215 15.4523 5.40345 15.4605 4.46301 15.4193C4.00103 15.3946 3.52256 15.2213 3.11008 14.9986C2.41712 14.6191 2.27688 13.9261 2.72235 13.2744C2.87909 13.0517 2.83784 12.9279 2.68935 12.7464C1.8644 11.74 1.05594 10.7253 0.239237 9.71061C0.164991 9.61987 0.0989946 9.52912 0 9.41363C0.214488 9.31463 0.404228 9.21564 0.602217 9.12489C1.37767 8.76191 2.15313 8.41543 2.92034 8.0442C3.12658 7.94521 3.29982 7.93696 3.50606 8.01945C4.92498 8.56392 6.3439 9.1084 7.76283 9.63637C7.88657 9.68586 8.05981 9.71061 8.16705 9.65287C9.61897 8.9764 11.0626 8.28344 12.5063 7.59873C12.5311 7.58223 12.5558 7.55748 12.6053 7.52448C10.2129 5.09911 7.82882 2.682 5.39521 0.215381C5.89843 0.190633 6.3274 0.165884 6.76463 0.149385C7.93607 0.0916381 9.124 0.0338913 10.3037 0.000893113C10.4934 -0.00735644 10.6997 0.0421409 10.8647 0.124636C13.6118 1.49406 16.3506 2.87174 19.0895 4.25766C19.2874 4.35665 19.4359 4.35665 19.6339 4.26591C21.4158 3.43271 23.1895 2.59125 24.9879 1.79929C26.1346 1.28782 27.3473 1.04859 28.6012 1.13108C29.5251 1.18883 30.3748 1.48581 31.1338 2.00553C31.5463 2.28602 31.8185 2.6655 31.9753 3.12747C31.9918 3.28421 31.9917 3.45745 31.9917 3.62245ZM8.39804 1.39507C10.5759 3.60595 12.6961 5.75083 14.8409 7.92871C14.7007 8.00296 14.6099 8.0607 14.5027 8.10195C12.4733 9.06715 10.4439 10.0241 8.42279 10.9975C8.16705 11.1213 7.96082 11.1378 7.68858 11.0305C6.29441 10.4861 4.89198 9.9581 3.48956 9.43013C3.38232 9.38888 3.23382 9.35588 3.13483 9.38888C2.7801 9.52912 2.44187 9.71061 2.06239 9.88385C2.93684 10.9728 3.80304 12.0452 4.66924 13.1177C4.38876 13.3817 4.12477 13.6374 3.81129 13.9261C4.00928 13.9839 4.13302 14.0251 4.26502 14.0499C5.22196 14.2396 6.17066 14.1571 7.12761 14.0416C8.53828 13.8684 9.90771 13.5302 11.2029 12.9279C14.7254 11.278 18.248 9.63637 21.7706 7.99471C24.3114 6.80677 26.8605 5.62709 29.3931 4.4144C29.7974 4.22466 30.1521 3.91118 30.5068 3.63069C30.7296 3.45745 30.6718 3.27596 30.4573 3.12747C30.0036 2.79749 29.5004 2.59125 28.9477 2.49226C27.768 2.27777 26.6378 2.49226 25.5654 2.97073C23.5855 3.86993 21.6056 4.80213 19.6339 5.72608C19.4277 5.82507 19.2627 5.82507 19.0565 5.71783C16.2351 4.29066 13.4138 2.87174 10.5842 1.45281C10.4604 1.38682 10.3119 1.32082 10.1799 1.32082C9.61897 1.32907 9.058 1.36207 8.39804 1.39507Z"
                  fill="currentColor"
                />
                <path
                  d="M1.04785 23.8586C1.04785 23.4378 1.04785 23.0254 1.04785 22.5881C11.1288 22.5881 21.2015 22.5881 31.3072 22.5881C31.3072 23.0089 31.3072 23.4131 31.3072 23.8586C21.2262 23.8586 11.1453 23.8586 1.04785 23.8586Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Departure</label>
              <DatePicker
                onChange={handleDepartureDate}
                peekNextMonth
                showMonthDropdown
                selected={Date.parse(state.DepartureDate)}
                showYearDropdown
                dropdownMode="select"
                minDate={todayMinDate}
                maxDate={endDateAll}
                dateFormat="YYYY-MM-DD"
                name="DepartureDate"
                placeholderText="Departure Date"
                value={
                  state.DepartureDate !== ""
                    ? slashFormatter(state.DepartureDate)
                    : ""
                }
                className="bf-input"
                autoComplete="off"
                onBlur={(e) => checkErrors(e)}
              />
              <span className="bf-error">{formErrors?.DepartureDate}</span>
            </div>
          </div>

          {tripType === "2" && (
            <div className="bf-field">
              <div className="bf-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                >
                  <path
                    d="M22.793 13.2798C24.7857 14.6326 26.1821 16.4653 26.1821 18.9089V23.2726H32.0002V18.9089C32.0002 15.738 26.8075 13.8617 22.793 13.2798Z"
                    fill="currentColor"
                  />
                  <path
                    d="M20.3633 11.6364C23.5778 11.6364 26.1814 9.03273 26.1814 5.81818C26.1814 2.60364 23.5778 0 20.3633 0C19.6796 0 19.0396 0.145454 18.4287 0.349091C19.636 1.84727 20.3633 3.75273 20.3633 5.81818C20.3633 7.88364 19.636 9.78909 18.4287 11.2873C19.0396 11.4909 19.6796 11.6364 20.3633 11.6364Z"
                    fill="currentColor"
                  />
                  <path
                    d="M11.6365 11.6364C14.8511 11.6364 17.4547 9.03273 17.4547 5.81818C17.4547 2.60364 14.8511 0 11.6365 0C8.422 0 5.81836 2.60364 5.81836 5.81818C5.81836 9.03273 8.422 11.6364 11.6365 11.6364ZM11.6365 2.90909C13.2365 2.90909 14.5456 4.21818 14.5456 5.81818C14.5456 7.41818 13.2365 8.72727 11.6365 8.72727C10.0365 8.72727 8.72745 7.41818 8.72745 5.81818C8.72745 4.21818 10.0365 2.90909 11.6365 2.90909Z"
                    fill="currentColor"
                  />
                  <path
                    d="M11.6364 13.0909C7.75273 13.0909 0 15.04 0 18.9091V23.2727H23.2727V18.9091C23.2727 15.04 15.52 13.0909 11.6364 13.0909ZM20.3636 20.3636H2.90909V18.9236C3.2 17.8763 7.70909 16 11.6364 16C15.5636 16 20.0727 17.8763 20.3636 18.9091V20.3636Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="bf-control">
                <label className="bf-label" htmlFor="">Return</label>
                <DatePicker
                  onChange={handleReturnDate}
                  peekNextMonth
                  showMonthDropdown
                  selected={Date.parse(state.ReturnDate)}
                  showYearDropdown
                  dropdownMode="select"
                  minDate={minReturn}
                  maxDate={endDateAll}
                  dateFormat="YYYY-MM-DD"
                  name="ReturnDate"
                  placeholderText="Return Date"
                  value={
                    state.ReturnDate !== ""
                      ? slashFormatter(state.ReturnDate)
                      : ""
                  }
                  className="bf-input"
                  autoComplete="off"
                  onBlur={(e) => checkErrors(e)}
                />
                <span className="bf-error">{formErrors?.ReturnDate}</span>
              </div>
            </div>
          )}

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="24"
                viewBox="0 0 32 24"
                fill="none"
              >
                <path
                  d="M22.793 13.2798C24.7857 14.6326 26.1821 16.4653 26.1821 18.9089V23.2726H32.0002V18.9089C32.0002 15.738 26.8075 13.8617 22.793 13.2798Z"
                  fill="currentColor"
                />
                <path
                  d="M20.3633 11.6364C23.5778 11.6364 26.1814 9.03273 26.1814 5.81818C26.1814 2.60364 23.5778 0 20.3633 0C19.6796 0 19.0396 0.145454 18.4287 0.349091C19.636 1.84727 20.3633 3.75273 20.3633 5.81818C20.3633 7.88364 19.636 9.78909 18.4287 11.2873C19.0396 11.4909 19.6796 11.6364 20.3633 11.6364Z"
                  fill="currentColor"
                />
                <path
                  d="M11.6365 11.6364C14.8511 11.6364 17.4547 9.03273 17.4547 5.81818C17.4547 2.60364 14.8511 0 11.6365 0C8.422 0 5.81836 2.60364 5.81836 5.81818C5.81836 9.03273 8.422 11.6364 11.6365 11.6364ZM11.6365 2.90909C13.2365 2.90909 14.5456 4.21818 14.5456 5.81818C14.5456 7.41818 13.2365 8.72727 11.6365 8.72727C10.0365 8.72727 8.72745 7.41818 8.72745 5.81818C8.72745 4.21818 10.0365 2.90909 11.6365 2.90909Z"
                  fill="currentColor"
                />
                <path
                  d="M11.6364 13.0909C7.75273 13.0909 0 15.04 0 18.9091V23.2727H23.2727V18.9091C23.2727 15.04 15.52 13.0909 11.6364 13.0909ZM20.3636 20.3636H2.90909V18.9236C3.2 17.8763 7.70909 16 11.6364 16C15.5636 16 20.0727 17.8763 20.3636 18.9091V20.3636Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control bf-guests">
              <label className="bf-label" htmlFor="">Travellers &amp; Class</label>

              <ul className={`bf-panel ${dropdown === "show" ? "show" : ""}`}>
                <li>
                  <div className="bf-panel-body">
                    <div className="bf-counter-row">
                      <div>
                        <h5 className="bf-counter-label">Adults</h5>
                        <h6 className="bf-counter-sub">(Aged 12+ yrs)</h6>
                      </div>
                      <SingleCounter
                        count={adultsCount}
                        max={8}
                        min={1}
                        inc={adultInc}
                        dec={adultDec}
                      />
                    </div>
                    <div className="bf-counter-row">
                      <div>
                        <h5 className="bf-counter-label">Children</h5>
                        <h6 className="bf-counter-sub">(Aged 2-12 yrs)</h6>
                      </div>
                      <SingleCounter
                        count={childsCount}
                        max={4}
                        min={0}
                        inc={childInc}
                        dec={childDec}
                      />
                    </div>
                    <div className="bf-counter-row">
                      <div>
                        <h5 className="bf-counter-label">Infants</h5>
                        <h6 className="bf-counter-sub">(Below 2 yrs)</h6>
                      </div>
                      <SingleCounter
                        count={infantsCount}
                        max={adultsCount}
                        min={0}
                        inc={infantInc}
                        dec={infantDec}
                      />
                    </div>

                    <div className="bf-travel-class">
                      <h3 className="bf-panel-title">Travel Class</h3>
                      <div className="bf-radio-group">
                        <label>
                          <input
                            type="radio"
                            name="travelClass"
                            value="1"
                            checked={travelClass === "1"}
                            onChange={handleClassChange}
                          />
                          <span>All</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="travelClass"
                            value="2"
                            checked={travelClass === "2"}
                            onChange={handleClassChange}
                          />
                          <span>Economy</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="travelClass"
                            value="3"
                            checked={travelClass === "3"}
                            onChange={handleClassChange}
                          />
                          <span>Premium Economy</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="travelClass"
                            value="4"
                            checked={travelClass === "4"}
                            onChange={handleClassChange}
                          />
                          <span>Business</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="travelClass"
                            value="6"
                            checked={travelClass === "6"}
                            onChange={handleClassChange}
                          />
                          <span>First Class</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="bf-panel-footer">
                    <a className="bf-btn-apply" onClick={handleApplyBtn}>
                      Apply
                    </a>
                  </div>
                </li>
              </ul>

              <input
                className="bf-input"
                type="text"
                onFocus={() => setDropdown("show")}
                placeholder={placeHolder}
                readOnly
              />
            </div>
          </div>

          <div className="bf-submit">
            <SearchButton func={handleFormSubmit} />
          </div>
        </form>
      </div>
    </>
  );
};

export default FlightForm;